import React, { useEffect, useState } from 'react'
import PlusIcon from '../../../../components/elements/icons/PlusIcon'
import FormButton from '../../../../components/elements/form/FormButton'
import Checkbox from '../../../../components/elements/form/Checkbox'
import RadioGroup from '../../../../components/elements/form/RadioGroup'
import TextField from '../../../../components/elements/form/TextField'
import TrashIcon from '../../../../components/elements/icons/TrashIcon'
import TextareaField from '../../../../components/elements/form/TextareaField'
import { ERROR, SET_SUCCESS } from '../../../../store/types'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { clearCreatedInventoryItemCategory, createInventoryItemCategory, fetchInventoryLocations } from '../../../../store/actions/inventoryActions'
import Loader from '../../../../components/elements/Loader'
import TagCloud from '../../../../components/elements/form/TagCloud'

const NewInventoryCategory = () => {
    const dispatch = useDispatch()
    const inventorySelector = useSelector(state => state.inventory)
    const navigate = useNavigate()
    const [categoryPayload, setCategoryPayload] = useState({});
    const [validationErrors, setValidationErrors] = useState({});

    const categoryField = {
        label: '',
        description: '',
        valueType: '',
        optional: true
    }

    const [categoryFields, setCategoryFields] = useState([categoryField]);

    useEffect(() => {
        dispatch(fetchInventoryLocations('', 0, 0))
        if(inventorySelector.createdCategory && inventorySelector.createdCategory !== null) {
            dispatch(clearCreatedInventoryItemCategory())
            dispatch({
                type: SET_SUCCESS,
                payload: 'New inventory item category created successfully!'
            })
            navigate('/user/inventory/categories')
        }
        return () => {
            
        };
    }, [dispatch, inventorySelector.createdCategory, navigate]);

    const [creatingCategoryFields, setCreatingCategoryFields] = useState(false);

    const addCategoryField = () => {
        const temp = [...categoryFields]
        temp.push(categoryField)
        setCategoryFields(temp)
    }

    const updateCategoryField = (index, field, value) => {
        const temp = [...categoryFields]
        temp[index][field] = value
        setCategoryFields(temp)
    }

    const removeCategoryField = (index) => {
        const temp = [...categoryFields]
        temp.splice(index, 1)
        setCategoryFields(temp)
    }
    

    const fieldTypes = [
        {
          label: 'Textfield',
          value: 'text',
          description: 'Use this for short, single line responses'
        },
        {
          label: 'Textarea',
          value: 'textarea',
          description: 'For long descriptive text'
        },
        {
          label: 'Number',
          value: 'number',
          description: 'For numeric and calculable responses'
        },
        {
          label: 'Date',
          value: 'date',
          description: 'For dates that need to be tracked'
        },
      ]

    const validateForm = () => {
        let errors = {}
        if(!categoryPayload.name || categoryPayload.name === ''){
            errors.name = true
        }
        if(!categoryPayload.description || categoryPayload.description === ''){
            errors.description = true
        }
        if(creatingCategoryFields){
            categoryFields.forEach((field, fieldIndex) => {
                if(!field.label || field.label === ''){
                    errors[`field-${fieldIndex}-label`] = true
                }
                if(!field.valueType || field.valueType === ''){
                    errors[`field-${fieldIndex}-value-type`] = true
                }
            })
        }

        setValidationErrors(errors)
        console.log('form errors: ', errors)
        return errors
    }
    
    const pushCategory = () => {
        if (Object.values(validateForm()).includes(true)) {
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            });
            return
        }
        const payload = {...categoryPayload}
        if(creatingCategoryFields){
            payload.additionalVariantFields = categoryFields
        }
        dispatch(createInventoryItemCategory(payload))
    }

    return (
        <>
            <div className='w-full xl:w-8/12 2xl:w-5/12 mt-[10px] mx-auto'>
                <div className='w-full'>
                    <div  className='w-full'>
                        <h3 className="font-space-grotesk font-[550] mb-1 text-[15px] text-gray-800">
                            Category Details
                        </h3>
                        <p className='text-xs text-gray-700 mt-2'>Please provide details of the inventory item category below to create the category.</p>
                    </div>
                    <div className='w-full mt-4'>
                        <div className='mb-4 w-full'>
                            <TextField
                                inputLabel="Category name" 
                                fieldId="document-name" 
                                inputType="text" 
                                inputPlaceholder={`Name the category`}
                                preloadValue={categoryPayload.name || ''}
                                hasError={validationErrors.name} 
                                returnFieldValue={(value)=>{setCategoryPayload({...categoryPayload, ...{name: value}})}}
                            />
                        </div>          
                    
                        <div className='mb-4 w-full'>
                            <TextareaField
                                inputLabel="Description" 
                                fieldId="dept-description" 
                                inputPlaceholder={`Description of this category`}
                                inputType="text" 
                                preloadValue={categoryPayload.description || ''}
                                hasError={validationErrors.description} 
                                returnFieldValue={(value)=>{setCategoryPayload({...categoryPayload, ...{description: value}})}}
                            />
                        </div>

                        <div className='mt-4 mb-3 w-full pb-3 border-b border-gray-300'>
                            <h3 className='font-space-grotesk font-[550] mb-1 text-[15px] text-gray-800'>Locations</h3>
                            <p className="text-sm text-gray-600">These are all the locations where this category would apply (Eg: textbooks for bookshops or library and Grains for kitchen). 
                                <br />
                                You can select multiple locatons
                            </p>
                        </div>

                        {inventorySelector.loadingLocations ? 
                            <Loader />
                        : <>
                            {inventorySelector?.locations?.locations?.length > 0 && <div className='my-2 w-full'>
                                <TagCloud 
                                    inputLabel="Select Locations"
                                    inputPlaceholder = 'Type and press Enter...'
                                    tags={inventorySelector.locations.locations.map(location => {
                                        return {
                                            label: location.name,
                                            value: location._id
                                        }
                                    })}
                                    preselected={[]}
                                    hasError={false}
                                    position='top'
                                    // position=
                                    helperText={'Search and select locations where this category applies'}
                                    returnFieldValue={(value)=>{setCategoryPayload({...categoryPayload, ...{locations: value}})}}
                                />
                            </div>}
                        </>}   

                        <div  className='w-full mt-4'>
                            <h3 className="font-space-grotesk font-[550] mb-1 text-[15px] text-gray-800">
                                Additional Category Fields
                            </h3>
                            <p className='text-xs text-gray-700 mt-2'>These fields are a way to add more descriptors to items in this category apart from the default fields (name, description, cost, serial number, condition, age, quantity). If they are provided, whenever an item is created for this category, these fields would be required.</p>
                        </div>  

                        <div onClick={()=>{setCreatingCategoryFields(!creatingCategoryFields)}} className='cursor-pointer flex flex-row gap-x-s justify-between items-start my-3 hover:bg-gray-100 transition duration-200 py-2 px-2 rounded'>
                            <span className='mt-[2px]'>
                                <Checkbox
                                    CheckboxLabel=""
                                    checkboxToggleFunction={()=>{setCreatingCategoryFields(!creatingCategoryFields)}} 
                                    isChecked={creatingCategoryFields} 
                                    hasError={false}
                                />
                            </span>
                            <div className='w-full'>
                                <p className='font-medium text-[13px]'>Do you want to create additional fields now?</p>
                            </div>
                        </div>           
                    </div>
                </div>

                {creatingCategoryFields && <div className='w-full'>
                    {categoryFields.map((field, fieldIndex)=>(<div key={fieldIndex} className='w-full'>
                        <div className='w-full flex items-center justify-between'>
                            <p className='uppercase tracking-[0.1em] text-xs font-[500]'>field {fieldIndex + 1}</p>
                            {fieldIndex > 0 && <button onClick={()=>{removeCategoryField(fieldIndex)}} className='w-[30px] h-[30px] text-gray-500 hover:text-red-600 flex items-center justify-center bg-transparent hover:bg-gray-200 rounded transition duration-200'>
                                <TrashIcon className={`w-5 h-5`} />                
                            </button>}
                        </div>
                        <div className='mb-4 w-full'>
                            <TextField
                                inputLabel="Label" 
                                fieldId={`field-${fieldIndex}-label`} 
                                inputPlaceholder={`Label displayed to the user`}
                                inputType="text" 
                                preloadValue={field.label || ''}
                                hasError={validationErrors[`field-${fieldIndex}-label`]} 
                                returnFieldValue={(value)=>{updateCategoryField(fieldIndex, 'label', value)}}
                            />
                        </div>
                        <div className='mb-4 w-full'>
                            <TextField
                                inputLabel="Description" 
                                fieldId={`field-${fieldIndex}-description`} 
                                inputPlaceholder={`Description of the label`}
                                inputType="text" 
                                preloadValue={field.description || ''}
                                hasError={false} 
                                returnFieldValue={(value)=>{updateCategoryField(fieldIndex, 'description', value)}}
                            />
                            <label className='block text-xs mt-1'>This description will be displayed to users when creating an inventory item of this category</label>
                        </div>
                        <div className='mb-4 w-full'>
                            <RadioGroup
                                inputLabel="Field type (What type of field should be presented to the reviewer?)"
                                inline={false}
                                items={fieldTypes} 
                                hasError={validationErrors[`field-${fieldIndex}-value-type`]} 
                                returnSelected={(value)=>{updateCategoryField(fieldIndex, 'valueType', value.value)}}
                            />
                        </div>
                        <div onClick={()=>{updateCategoryField(fieldIndex, 'optional', !field.optional)}} className='cursor-pointer flex flex-row gap-x-s justify-between items-start my-3 hover:bg-gray-100 transition duration-200 py-2 px-2 rounded'>
                            <span className='mt-[2px]'>
                                <Checkbox
                                    CheckboxLabel=""
                                    checkboxToggleFunction={()=>{updateCategoryField(fieldIndex, 'optional', !field.optional)}} 
                                    isChecked={!field.optional} 
                                    hasError={false}
                                />
                            </span>
                            <div className='w-full'>
                                <p className='font-medium text-[13px]'>Check this box if this field must be provided for each variant added.</p>
                            </div>
                        </div>
                    </div>))}
                    <div className='flex flex-row-reverse mt-[20px]'>
                        <button onClick={()=>{addCategoryField()}} className='flex items-center justify-center font-[500] text-xs gap-x-[5px] border border-vcm-purple bg-vcm-light-purple bg-opacity-50 text-vcm-purple rounded p-[10px]'>
                            <PlusIcon className={`w-5 h-5`} />
                            Add another field
                        </button>
                    </div>
                </div>}

                <div className='my-8 flex flex-row-reverse items-center justify-between pt-8 border-t'>
                    <div className='min-w-[200px]'>
                        <FormButton buttonLabel={`Create Category`} buttonAction={()=>{pushCategory()}} processing={inventorySelector.creatingCategory} />
                    </div>
                </div>
            </div>
        </>
    )

}

export default NewInventoryCategory